<template>
  <keep-alive>
    <slot></slot>
  </keep-alive>
</template>

<script>
export default {
  name: 'SuiPageTabHeadlessType',
  props: {
    defaultTabIndex: {
      type: Number,
      default: -1
    },
    tabItems: {
      type: Array,
      required: true
    },
    setCurrentTabComponent: {
      type: Function,
    },
  },
  data: function() {
    return {
      currentTabIndex: -1,
    }
  },
  mounted() {
    if (this.defaultTabIndex >= 0) {
      this.changeIdx(this.defaultTabIndex);
    }
  },
  methods: {
    loadTabComponent(component) {
      if (!component) {
        return;
      }
      if (this.isPageComponent(component)) {
        utils.loadPageMeta(component).then(meta=> {
          this.setCurrentTabComponent(component);
          this.$nextTick(()=>{
            this.$emit('component-changed', component);
          })
        }).catch(error => {

        })
      } else {
        this.setCurrentTabComponent(component);
        this.$nextTick(()=>{
          this.$emit('component-changed', component);
        });
      }
    },
    changeIdx(idx) {
      if (this.currentTabIndex !== idx && idx < this.tabItems.length) {
        this.currentTabIndex = idx
        if (idx >= 0) {
          this.loadTabComponent(this.tabItems[this.currentTabIndex].component);
        }
        // this.$emit('change-tab-idx', idx);
      }
    },
    select(idx) {
      this.changeIdx(idx);
    },
    isPageComponent(component) {
      if (typeof component === 'string' && component.length === 13) {
        const splittedStr = component.split('_');
        if (splittedStr.length === 3 && splittedStr[0] === 'PGE') {
          return true;
        }
      }
      return false;
    },
    getSelectedIndex() {
      return this.currentTabIndex;
    },
  },  
}
</script>
